import PropTypes from 'prop-types';
import StarRating from '../../../../../rating_and_reviews/star_rating';
import Translation from '../../../../../translation/translation';
import getTranslatedText from '../../../../../../helper/get_translated_text';

function FitterReview(props) {
    return (
        <div className="fsf-station__fitter-review">
            <div className="fsf-station__fitter-review-header">
                <StarRating
                    additionalClassNames={['fsf-station__fitter-review-rating']}
                    rating={props.data.rating}
                />
                <Translation
                    translationKey="fitting-station-finder-app-station-review-author"
                    placeholder={{
                        author: props.data.firstName + ' ' + props.data.lastName,
                        date: props.data.date
                    }}
                    className="fsf-station__fitter-review-author-and-date"
                />
            </div>
            <div className="fsf-station__fitter-review-content">
                {props.data.text !== '' ?
                    props.data.text :
                    <Translation translationKey="fitting-station-finder-app-station-review-default-text" className="fsf-station__fitter-review-no-text" />
                }
            </div>
            {
                '' !== props.data.fitterComment ?
                    <div className="fsf-station__fitter-review-reply">
                        <div className="fsf-station__fitter-review-reply--author">
                            {
                                getTranslatedText(
                                    'fitting-station-finder-app-stations-review-reply-header',
                                    {
                                        'fsName': props.fsName,
                                        'replyDate': props.data.fitterCommentDate
                                    }
                                )
                            }
                        </div>
                        <div className="fsf-station__fitter-review-reply--content">
                            {props.data.fitterComment}
                        </div>
                    </div> :
                    ''
            }
        </div>
    );
}

FitterReview.propTypes = {
    data: PropTypes.object,
    fsName: PropTypes.string,
};

FitterReview.defaultProps = {
    data: {},
    fsName: '',
};

export default FitterReview;